var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.213867,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E3E9FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7504_77793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4483 9.87677H12.1347C10.8091 9.87677 10.1463 9.87677 9.64 10.1347C9.19464 10.3617 8.83255 10.7238 8.60563 11.1691C8.34766 11.6754 8.34766 12.3382 8.34766 13.6638V20.2911C8.34766 21.6167 8.34766 22.2795 8.60563 22.7858C8.83255 23.2311 9.19464 23.5932 9.64 23.8201C10.1463 24.0781 10.8091 24.0781 12.1347 24.0781H18.762C20.0876 24.0781 20.7504 24.0781 21.2567 23.8201C21.702 23.5932 22.0641 23.2311 22.291 22.7858C22.549 22.2795 22.549 21.6167 22.549 20.2911V16.9774M13.0814 19.3443H14.4026C14.7885 19.3443 14.9815 19.3443 15.1631 19.3007C15.3241 19.2621 15.478 19.1983 15.6192 19.1118C15.7784 19.0142 15.9149 18.8778 16.1878 18.6049L23.7325 11.0602C24.3861 10.4066 24.3861 9.34692 23.7325 8.69332C23.0789 8.03973 22.0192 8.03972 21.3656 8.69332L13.8209 16.238C13.548 16.5109 13.4115 16.6473 13.3139 16.8066C13.2274 16.9478 13.1637 17.1017 13.125 17.2627C13.0814 17.4443 13.0814 17.6373 13.0814 18.0232V19.3443Z",
    stroke: "#1638B1",
    strokeWidth: 1.70089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7504_77793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1429,
    height: 19.2768,
    fill: "white",
    transform: "translate(7.21387 6.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6c052acda18bd25d2f0900fa35e84a2c.svg";
export { ForwardRef as ReactComponent };